<script>
require ('../../public/css/contact.css');
import contactForm from './contact-form.vue';
export default {
    name: 'contactSection',
    components: {
        contactForm
    }
};
</script>

<template>

    <section class="contact" id="contact">

        <div class="container">

            <div class="contact__wrapper">

                <div class="contact__info">

                    <span class="contact__subtitle">

                        {{ 'GET IN TOUCH' | i }}

                    </span>

                    <h2 class="contact__title">
                        {{ 'contact_section'| staticTitle }}
                    </h2>

                    <vue-marked>{{ 'contact_section' | staticContent }}</vue-marked>

                    <!-- 
                    <p class="contact__description">

                        Whether you're looking to launch a visionary project, explore investment opportunities,
                        or discuss a strategic partnership, our team is ready to help turn your ideas into reality.

                    </p>

                    <div class="contact__details">

                        <div class="contact__item">

                            <span class="contact__label">

                                {{ 'Email' | i }}

                            </span>

                            <a href="mailto:info@bridgerocksworld.com">

                                info@bridgerocksworld.com

                            </a>

                        </div>

                        <div class="contact__item">

                            <span class="contact__label">

                                {{ 'Phone' | i }}

                            </span>

                            <a href="tel:+10000000000">

                                +1 (000) 000-0000

                            </a>

                        </div>

                        <div class="contact__item">

                            <span class="contact__label">

                                {{ 'Headquarters' | i }}

                            </span>

                            <p>

                                Miami, Florida, United States

                            </p>

                        </div>

                        <div class="contact__item">

                            <span class="contact__label">

                                {{ 'Business Hours' | i }}

                            </span>

                            <p>

                                Monday – Friday<br>
                                9:00 AM – 6:00 PM

                            </p>

                        </div>

                    </div> -->

                </div>

                <div class="contact__form">

                    <contact-form />

                </div>

            </div>

        </div>

    </section>
</template>